<template>

  <div class="bootstrap">
    <div class="row m-4" v-if="!orderReady">
      <div class="col text-center">
        <div class="image-container">
          <img :src="product.list_image" alt=""/>
        </div>
        <br/>
        <br/>
        (арт. {{ product.articul }}), {{ product.name }}
        <br/>
        <br/>
        <h4>
          <money :price="product.current_price"/>
        </h4>
      </div>
      <div class="col">
        <p>&nbsp;</p>
        <div class="text-danger" v-if="errorMessage">{{ errorMessage }}</div>
        <input type="text" :class="errorFields.includes('fio') && 'is-invalid'" class="form-control" v-model="fio" placeholder="Ваше имя..."/>
        <input type="text"  :class="errorFields.includes('email') && 'is-invalid'" class="form-control" v-model="email" placeholder="Ваш email..."/>
        <input type="text" :class="errorFields.includes('phone') && 'is-invalid'" class="form-control" v-model="phone" placeholder="Ваш телефон..."/>
      </div>
    </div>
    <div v-if="!orderReady">
      <button class="btn-orange " @click="send()"><i class="icon-cart"></i> Оформить заказ</button>
    </div>
    <div class="row m-4 text-center" v-if="orderReady">
      <h3>Ваш заказ успешно оформлен!</h3>
      <h6>В ближайшее время в Вами свяжется менеджер и уточнит условия доставки заказа</h6>
    </div>
  </div>
</template>


<script>
import Money from "../core/Money";
import {validateEmail, validatePhone} from "@/utils";

export default {
  name: 'QuickOrder',
  components: {Money},
  props: ['product'],
  data() {
    return {
      fio: null,
      email: null,
      phone: null,
      errorMessage: null,
      errorFields: [],
      orderReady: false,
    }
  },
  methods: {
    send() {
      this.errorMessage = '';
      this.errorFields = [];

      if (!this.fio) {
        this.errorMessage += 'Необходимо заполнить ФИО. ';
        this.errorFields.push('fio')
      }
      if (!this.email) {
        this.errorMessage += 'Необходимо заполнить  Email.';
        this.errorFields.push('email')
      }
      if (!this.phone) {
        this.errorMessage += 'Необходимо заполнить контактный телефон. ';
        this.errorFields.push('phone')
      }
      if (this.email && !validateEmail(this.email)) {
        this.errorMessage += 'Email заполнен неверно. ';
        this.errorFields.push('email')
      }
      if (this.phone && !validatePhone(this.phone)) {
        this.errorMessage += 'Телефон заполнен неверно. ';
        this.errorFields.push('phone')
      }

      if (this.errorMessage) {
        return
      }

      this.$http.post('/customer/create-quick-order', {
        fio: this.fio,
        email: this.email,
        phone: this.phone,
        product_id: this.product.id,
        checkString: btoa(new Date().getTime() + 'checked')
      }).then((result) => {
        result
        this.orderReady = true
      }, (error) => {
        this.errorMessage = error.message
      });

    }
  }
}
</script>

<style scoped>
.bootstrap {
  z-index: 2000;
}

.btn-orange {
  width: 100%;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

</style>
